import { Injectable } from '@angular/core';
import { Project } from 'src/app/models/firebase/project';
import { User } from 'src/app/models/firebase/user';
import { AuthService } from '../auth/auth.service';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { UserProfile } from 'src/app/models/firebase/userProfile';
import { ApiService } from '../api/api.service';
import { getFileNameExtension, isNullOrUndefined } from '@pineapplelab/util';
import { StorageService } from '../storage/storage.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private db: AngularFirestore, private api: ApiService, private storageService: StorageService) { }

  async getUserById(userId: string): Promise<User> {
    const snapshot = await this.db.firestore
      .collection(Project.PATH)
      .doc(AuthService.projectId)
      .collection(User.PATH)
      .doc(userId)
      .get();
    return new User(snapshot.data());
  }
  async getUsers(): Promise<User[]> {
    const snapshot = await this.db.firestore
      .collection(Project.PATH)
      .doc(AuthService.projectId)
      .collection(User.PATH)
      .get();
    return snapshot.docs.map((doc) => new User(doc.data()));
  }

  async getProfilesByUserId(userId: string): Promise<UserProfile[]> {
    const snapshot = await this.db.firestore
      .collection(Project.PATH)
      .doc(AuthService.projectId)
      .collection(User.PATH)
      .doc(userId)
      .collection(UserProfile.PATH)
      .get();
    return snapshot.docs.map((doc) => new UserProfile(doc.data()));
  }
  async getProfileByUserId(userId: string, profileId: string): Promise<UserProfile> {
    const snapshot = await this.db.firestore
      .collection(Project.PATH)
      .doc(AuthService.projectId)
      .collection(User.PATH)
      .doc(userId)
      .collection(UserProfile.PATH)
      .doc(profileId).get()
    return new UserProfile(snapshot.data());
  }

  async deleteUser(userId: string): Promise<void> {
    try {
      const result = await this.api.delete('/user/' + userId);
      if (isNullOrUndefined(result)) {
        return;
      }
    } catch (error) {
      throw error;
    }
  }

  async updateUser(json: any): Promise<void> {
    try {
      const result = await this.api.put('/user', json);
      if (isNullOrUndefined(result)) {
        return;
      }
    } catch (error) {
      throw error;
    }
  }

  async updateImageUser(file: File, userId: string): Promise<void> {
    const commonPath = `${Project.PATH}/${AuthService.projectId}/${User.PATH}/${userId}`;
    if (isNullOrUndefined(file)) {
      return;
    }
    const path = `${commonPath}/avatar.${getFileNameExtension(file.name)}`;
    const url = await this.storageService.uploadFile(path, file);
    return await this.db.firestore
      .collection(Project.PATH)
      .doc(AuthService.projectId)
      .collection(User.PATH)
      .doc(userId)
      .update({ avatar: url });
  }
  async updateUserProfileStatus(userProfile: UserProfile): Promise<void> {
    return await this.db.firestore
      .collection(Project.PATH)
      .doc(AuthService.projectId)
      .collection(User.PATH)
      .doc(userProfile.artistId)
      .collection(UserProfile.PATH)
      .doc(userProfile.uid)
      .update(userProfile.toJson());
  }
}
